<!-- 本科首页头部-组件级 -->
<template>
  <div class='header-wrap'>
    <div class='page-header clearfix'>
      <div class='header-logo fl'>
        <img :src='logo'
             alt="再来人Logo"
             calss="logo"
             width="160px"
             @click="handleHome"
             class="logo">
      </div>
      <ul class='header-menu fl'>
        <li :class="[(activeName === item.id) ? 'active' : '', 'fl']"
            v-for='item in menuList'
            :key='item.id'
            @click="tabMenu(item)">
          <a href="javascript: void(0)">{{item.name}}</a>
        </li>
      </ul>
      <ul class='header-user fr'>
        <li class="warn fl"
            @click="goMessage">
          <img :src='noWarning' />
          <!-- <div class='point'></div> -->
        </li>
        <li class="user fl">
          <zlr-personal></zlr-personal>
          <!-- <img src='' /> -->
          <!-- <ul class='user-menu'></ul> -->
        </li>
      </ul>
    </div>
  </div>
</template>

<script>
import logo from '@/assets/Logo.svg'
import warning from '@/assets/undergraduate/images/warning.png'
import noWarning from '@/assets/undergraduate/images/no_warning.png'
import ZlrPersonal from './dropdown/dropdown'
export default {
  name: '',
  components: {
    ZlrPersonal
  },
  data () {
    return {
      // logo图
      logo,
      // 提示信息
      warning,
      noWarning,
      // 头部菜单
      menuList: [
        {
          id: 'home',
          name: 'Home',
          path: '/undergraduate/index'
        },
        {
          id: 'mentee',
          name: 'Mentee',
          path: '/undergraduate/mentee'
        },
        {
          id: 'materials',
          name: 'Materials',
          path: '/undergraduate/materials'
        },
        {
          id: 'timesheet',
          name: 'Timesheet',
          path: '/undergraduate/timesheet'
        }
      ],
      activeName: ''
    }
  },
  computed: {},
  mounted () {
    this.activeName = this.$route.meta.menu
  },
  methods: {
    // logo跳转
    handleHome () {
      this.$router.push({
        path: '/undergraduate/index'
      })
    },
    // 菜单切换
    tabMenu (item) {
      this.activeName = item.id
      this.$router.push({
        path: item.path
      })
    },
    // 站内信跳转
    goMessage () {
      this.$router.push({
        path: '/undergraduate/personal/message'
      })
    }
  },
  watch: {
    $route (to, from) {
      this.activeName = to.meta.menu
    }
  }
}
</script>
<style lang='less' scoped>
.clearfix {
  *zoom: 1;
}
.clearfix::after {
  content: "";
  display: block;
  clear: both;
}
.fl {
  float: left;
}
.fr {
  float: right;
}
img {
  display: block;
  border: none;
}
ul li {
  margin: 0;
  padding: 0;
  list-style-type: none;
}
.header-wrap {
  width: 100%;
  height: 100px;
  background: #ffffff;
  box-shadow: 0 8px 16px 0 #e6eaf1;
  position: absolute;
  top: 0;
  left: 0;
  .page-header {
    padding: 0 20px;
    width: 1280px;
    margin: 0 auto;
    .header-logo {
      width: 214px;
      height: 64px;
      padding-top: 36px;
      img {
        width: 100%;
        height: 100%;
      }
    }
    .header-menu {
      padding-left: 20px;
      padding-top: 36px;
      li {
        cursor: pointer;
        margin: 0 22px;
        line-height: 60px;
        font-size: 18px;
        letter-spacing: 0;
        border-bottom: 4px solid #fff;
        &.active {
          border-bottom: 4px solid #4aa6ff;
        }
        a {
          color: #323c47;
        }
      }
    }
    .header-other {
      padding-top: 6px;
      li {
        cursor: pointer;
        margin: 22px;
        text-align: center;
        img {
          width: 28px;
          height: 28px;
          margin: 0 auto;
        }
        p {
          line-height: 28px;
          font-size: 12px;
          color: #4aa6ff;
          letter-spacing: 0;
        }
      }
    }
    .header-user {
      padding: 36px 20px 36px 30px;
      .warn {
        cursor: pointer;
        margin: 0 44px 0 22px;
        img {
          width: 21px;
          height: 25px;
        }
      }
      .user {
        cursor: pointer;
        margin-top: -10px;
        width: 50px;
        height: 50px;
        background: #f2f2f2;
        border-radius: 50px;
      }
    }
  }
}
</style>
